import { render, staticRenderFns } from "./OrgInfo.vue?vue&type=template&id=133bc863&scoped=true&"
import script from "./OrgInfo.vue?vue&type=script&lang=js&"
export * from "./OrgInfo.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./OrgInfo.vue?vue&type=style&index=0&id=133bc863&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "133bc863",
  "031b4dd2"
  
)

export default component.exports